import Vue from 'vue';
import { Message } from 'element-ui';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import * as moment from 'moment';
import * as Sentry from '@sentry/vue';
import VueMoment from 'vue-moment';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGtag from 'vue-gtag';
import VueGtm from '@gtm-support/vue2-gtm';
import pkg from '../package.json';
import i18n from './i18n';
import { zhTW } from './helpers/moment-locale';
import 'sweetalert2/dist/sweetalert2.min.css';
import BodyScrollLock from './helpers/body-scroll-lock';

Vue.directive('body-scroll-lock', BodyScrollLock);

Vue.config.productionTip = false;
Vue.prototype.$message = Message;

moment.locale('zh-Hant-my-settings', zhTW);

moment.defineLocale('zh-Hant', {
  parentLocale: 'zh-TW',
});

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueSweetalert2);

const clientGATracker = document.querySelector('meta[property="tracker:google-analytics"]')?.content;
const clientGTMTracker = document.querySelector('meta[property="tracker:google-tag-manager"]')?.content;
const clientFbTracker = document.querySelector('meta[property="tracker:facebook-pixel"]')?.content;

const VueGtagConfig = {
  config: { id: 'UA-60306476-8' },
};

if (clientGATracker) {
  VueGtagConfig.includes = [{ id: 'G-WZ7M7HG0QY' }, { id: clientGATracker }];
} else {
  VueGtagConfig.includes = [{ id: 'G-WZ7M7HG0QY' }];
}

Vue.use(VueGtag, VueGtagConfig, router);

if (clientGTMTracker) {
  Vue.use(VueGtm, {
    id: clientGTMTracker,
    defer: true,
    vueRouter: router,
  });
}

/* eslint-disable */
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
/* eslint-enable */

if (clientFbTracker) {
  window.fbq('init', clientFbTracker);
  window.fbq('init', '424064264619785');
} else {
  window.fbq('init', '424064264619785');
}

window.fbq('track', 'PageView');

Sentry.init({
  Vue,
  release: pkg.version,
  dsn: 'https://cf4522d0c489fa4ffb5265490dfafd82@o4509002132946944.ingest.us.sentry.io/4509002414424064',
  environment: process.env.NODE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  // 暫時停用 Sentry，將所有採樣率設為 0
  tracesSampleRate: 0, // 原為 0.2 (20% of transactions)
  replaysSessionSampleRate: 0, // 原為 0.05 (5% of sessions)
  replaysOnErrorSampleRate: 0, // 原為 0.5 (50% of sessions with errors)
  enabled: false,
});

Vue.prototype.$Sentry = Sentry;

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
